import React from "react";

import asIcon from "./asIcon";

export default asIcon(
  ({ color }) =>
    <path fill={color} d="M71.9 83L38.8 49.9l33.1-33.1a4.5 4.5 0 0 0 0-6.4l-.7-.7a4.5 4.5 0 0 0-6.4 0L27.9 46.6a4.5 4.5 0 0 0-.6 5.7 5 5 0 0 0 .9 1.4l36.6 36.5a5.1 5.1 0 0 0 7.1-7.2z" />,
);
